import client from './client';
import axios from 'axios';
import jwt from 'jsonwebtoken';
import diagnosis from '../../modules/diagnosis';

//=============== CREATE ===============//
// 사용자 문진 업로드: 기존 사용자
export const postUserConditions = ({ data, user_id }) =>
  client.put(`/my/account/user/${user_id}`, data).then((item) => {
    console.log(
      `/my/account/user/${user_id} result ----->  보낸 데이터 `,
      data,
    );
    console.log(
      `/my/account/user/${user_id} result ----->  받는 데이터 `,
      item,
    );
    return item;
  });

// 사용자 문진 업로드: 임시 사용자
export const postTemporaryUserConditions = ({ data }) =>
  client.post('/shampoo/temporary-auth/join', data);

// 임시 사용자 토큰 발급
export const postTemporaryUserAuth = ({ data }) =>
  client.post('/shampoo/temporary-auth/accesstoken', data);

// 샴푸 등록 or 샴푸수정요청 to 구글 시트
export const postShampooRegister = ({ type, data }) => {
  const payload = {
    iss: 'googlesheets@withbecon-231fb.iam.gserviceaccount.com',
    scope: 'https://www.googleapis.com/auth/spreadsheets',
    aud: 'https://oauth2.googleapis.com/token',
  };

  // github의 secret key 형식 바꿈
  const token = jwt.sign(
    payload,
    process.env.REACT_APP_GOOGLE_SERVICE_ACCOUNT_PRIVATE_KEY,
    {
      algorithm: 'RS256',
      expiresIn: '5m',
    },
  );

  return axios
    .request({
      url: '/token',
      method: 'post',
      baseURL: 'https://oauth2.googleapis.com',
      data:
        'grant_type=urn%3Aietf%3Aparams%3Aoauth%3Agrant-type%3Ajwt-bearer&assertion=' +
        token,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
    .then((response) => response.data.access_token)
    .then((access_token) => {
      const params = {
        spreadsheetId: '1x_T7GNpDcyUYffPwPCmkqENXBtE5_dmzpCDNmjOsJwQ',
        range:
          process.env.REACT_APP_SERVER_BASE_URL === 'stg'
            ? type === 'new'
              ? 'new_dev!A1:G1'
              : 'amend_dev!A1:I1'
            : type === 'new'
            ? 'new!A1:G1'
            : 'amend!A1:I1',
        valueInputOption: 'USER_ENTERED',
        access_token: access_token,
        resource: {
          values: [data],
        },
      };
      return window.gapi.client.sheets.spreadsheets.values.append(params);
    })
    .then((response) => {
      window.dataLayer &&
        window.dataLayer.push({
          event: 'becon',
          action: type === 'new' ? 'requestNewShampoo' : 'requestAmendShampoo',
        });
      return { data: response.result.updates };
    });
};

//=============== READ ===============//
// 샴푸 리스트
export const getShampooList = () => client.get('/shampoo/list');

// 샴푸 분석 결과
export const postShampooResult = ({ user_id, product_id, diagnosis_items }) => {
  if (diagnosis_items) {
    console.log('/shampoo/analysis/with-scalp  ---> product_id', product_id);
    return client
      .post(`/shampoo/analysis/with-scalp`, {
        user_id: user_id,
        product_id: product_id,
        scalp_diagnosis_items: diagnosis_items,
      })
      .then((item) => {
        console.log('샴푸 분석 결과, ---> ', item);
        return item;
      });
  } else {
    return client
      .post(`/shampoo/analysis/with-passthrough`, {
        user_id: user_id,
        product_id: product_id,
      })
      .then((item) => {
        console.log('item');
        return item;
      });
  }
};

// 전성분
export const getShampooIngredients = ({ user_id, analysis_id }) =>
  client.get(`/shampoo/my/${user_id}/result/${analysis_id}/ingredients`);

//분석 히스토리
export const getShampooHistories = ({ user_id }) =>
  client.get(`/shampoo/my/${user_id}/results`);

//나에게 맞는 상위 5개 샴푸
export const getTopRankedShampooList = ({ user_id, diagnosis_items }) => {
  if (diagnosis_items) {
    return client
      .post(`/shampoo/my/${user_id}/shampoo-ranks/with-scalp`, {
        size: 5,
        scalp_diagnosis_items: diagnosis_items,
      })
      .then((item) => {
        console.log('item!!!', item);
        return item;
      });
  } else {
    return client.get(`/shampoo/my/${user_id}/shampoo-ranks?size=5`);
  }
};

//=============== UPDATE ===============//

//=============== DELETE ===============//
